import { render, staticRenderFns } from "./ArchiveProjects.vue?vue&type=template&id=a0357fce&"
import script from "./ArchiveProjects.vue?vue&type=script&lang=js&"
export * from "./ArchiveProjects.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveProjects.vue?vue&type=style&index=0&id=a0357fce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports